/* eslint-disable prefer-template */
/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from '../../../api/util/createPromiseRequest';
import { hasAccessToken } from '../../../../../utils/token';

export const listPsqlCustomersEntities = ({ customerName } = {}) => {
	const url = '/' + ['rel', 'customers','entities', customerName].filter(v => v && v !== 'Aegion').join('/');

	if (hasAccessToken()) {
		const fetch = createPromiseRequest({
      url,
      aip: 'admin',
      method: 'POST',
      data: {
        format: 'OBJECT'
      }
		});

    return fetch().then(res => res?.data);
	}
	return Promise.reject(new Error('Missing token'));
};
